import { makeStyles } from '@griffel/react';

import { tokens } from '../../../../util/theme/fluent9';

export const useClassNames = makeStyles({
  outerLeftNav: {
    backgroundColor: tokens.colorNeutralBackground4,
  },
});
